/**
 * Language to moment locale map
 * @type {Object}
 */
export const langMapping = {
    'arm': 'hy-am',
    'tur': 'tr',
    'rus': 'ru',
    'eng': 'en',
    'gre': 'el',
    'kor': 'ko',
    'pol': 'pl',
    'ger': 'de',
    'ita': 'it',
    'cze': 'cs',
    'spa': 'es',
    'por': 'pt',
    'geo': 'ka',
    'lit': 'lt',
    'lat': 'lv',
    'jpn': 'ja',
    'fas': 'fa',
    'nor': 'nb',
    'swe': 'sv',
    'bos': 'bs',
    'hrv': 'hr',
    'mac': 'mk',
    'slv': 'sl',
    'srp': 'sr',
    'heb': 'he',
    'chi': 'zh-tw',
    'bgr': 'bg',
    'vnm': 'vi',
    'zhh': 'zh-cn',
    'ukr': 'uk',
    "kur": 'ar', // Set to arabic since moment.js does not have kurdish for now
    "fra": 'fr',
    "arb": 'ar',
    "rum": 'ro'
};